import { HeroSection, LoadingSpinner, Section, SectionSubtitle, SectionTitle } from '@web_opxp/components';
import { LanguageSelectors, useTranslation } from '@web_opxp/features';
import React from 'react';
import { connect } from 'react-redux';
import { AppSelectors } from '../app';
import Env from '../base/env';
import { IState } from '../store/state';
import { MigrationActions } from './slice';

export const MigrationRoute = '/migration';

export interface IMigrationProps {
  // app is loaded
  loaded: boolean;
  onOpen: () => void;
}

export const MigrationFC: React.FC<IMigrationProps> = ({ loaded, onOpen }) => {
  const { t } = useTranslation();
  React.useEffect(() => {
    if (loaded) {
      onOpen();
    }
  }, [loaded, onOpen]);
  return (
    <>
      <HeroSection lottie="brain">
        <SectionTitle>{t('Migration.Title')}</SectionTitle>
        <SectionSubtitle>{t('Migration.Intro')}</SectionSubtitle>
      </HeroSection>
      <Section>
        <LoadingSpinner assetsUrl={Env.AssetsBaseUrl} />
      </Section>
    </>
  );
};

export const mapStateToProps = (state: IState) => {
  const appLoaded = AppSelectors.isAppReady(state);
  const languageLoading = LanguageSelectors.isLoading(state);
  const loaded = appLoaded && !languageLoading;
  return { loaded };
};

export const mapDispatchToProps = {
  onOpen: MigrationActions.initMigration,
};

const Migration = connect(mapStateToProps, mapDispatchToProps)(MigrationFC);
export default Migration;
